(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/coupon-settings-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/coupon-settings-reducer.js');
"use strict";


const _RTK = RTK,
  combineReducers = _RTK.combineReducers;
const _svs$components$tipse = svs.components.tipsen.store.reducers,
  tipsinfoReducer = _svs$components$tipse.tipsinfoReducer,
  compressedCouponReducer = _svs$components$tipse.compressedCouponReducer;
const couponSettingsReducer = combineReducers({
  CompressedCoupon: compressedCouponReducer,
  Tipsinfo: tipsinfoReducer
});
setGlobal('svs.components.tipsen.store.reducers.couponSettingsReducer', couponSettingsReducer);

 })(window);